<template>
	<div class="category-list">
		<div 
			class="grid grid-flow-row"
			:class="[
				`grid-cols-${ 
					screenSize === 'mobile'
					? 1
					: cols 
				}`,
				{
					'gap-8': screenSize === 'mobile',
					'gap-4': screenSize !== 'mobile',
				}
			]"
		>
			<div
				v-for="(g, g_ndx) in cats"
				:key="`group_${ g_ndx }`"
				class="text-sm flex flex-col gap-4"
				:class="[`col-span-${
					screenSize === 'mobile'
					? 1
					: this.config[g.title] || 1
				}`]"
			>
				<div class="pb-5 border-b-1 border-gray-003">
					<span 
						:class="{
							'text-white font-semibold text-xl': screenSize === 'mobile',
							'text-gray-006': screenSize !== 'mobile',
						}"
					>{{ g.title }}</span>
				</div>
				<div
					class="grid grid-flow-col gap-4"
					:style="{
						'grid-template-rows': `repeat(${ calcRows(g.list) }, minmax(0, 1fr)) !important`
					}"
				>
					<div
						v-for="(item, ndx) in g.list"
						:key="ndx"
						class="row-span-1 text-sm"
					>
						<a 
							:href="`${ baseUrl }${ 
								item.url[0] === '/'
								? item.url.slice(1)
								: item.url
							}`" 
							@click.native="categoryClick(item)"
						>{{ item.name }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import store from '@/store'

/* eslint-disable no-console */ 
export default {
	name: 'CategoryList',
	props: {
		cols: {
			type: Number,
			default: null
		},
		config: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			screenSize: null
		}
	},
	mixins: [
		globalMixins
	],
	computed: {
		cats() {
			return  store.getters.categories
		}
	},
	methods: {
		categoryClick(item) {
			const { url, name } = item
			this.analytics({
				event: 'Click',
				label: 'Category | ' + name + ' | ' + url
			})
		},
		calcRows(list) {
			return this.cols
				? Math.round(list.length / this.cols)
				: 'auto'
		},
		resize() {
			this.setScreenSize()
		},
		setScreenSize() {
			this.screenSize = window.innerWidth > 769 && window.innerWidth <= 1024
				? 'tablet'
				: window.innerWidth > 1024 && window.innerWidth <= 1280
				? 'laptop'
				: window.innerWidth > 1280 && window.innerWidth <= 1920
				? 'desktop'
				: window.innerWidth > 1920
				? 'tv'
				: 'mobile'
		},
	},
	mounted() {
		this.setScreenSize()
	},
	beforeMount() {
    window.addEventListener('resize', this.resize);
	},
  beforeUnmount() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>